import { Api } from '@api/index';
import { injectTSDI } from '../core/tsdi';

export function sortBy<PROPERTY extends string>(property: PROPERTY) {
    type ObjectWithProperty = Record<PROPERTY, unknown>;

    return (obj1: ObjectWithProperty, obj2: ObjectWithProperty) =>
        obj1[property] === obj2[property]
            ? 0
            : obj1[property] > obj2[property]
            ? 1
            : -1;
}

export const cancelUrl = (tenantName: string, studioId?: number): string => {
    const baseCancelContractUrl = window.location.host
        .replace('checkout', 'public')
        .replace('.moresports.io', '.magicline.com');
    const studioIdParam = studioId ? `&studio=${studioId}` : '';
    return `https://${baseCancelContractUrl}/#/contractTermination?tenant=${tenantName}${studioIdParam}`;
};

export const ibanFormatter = (iban?: string) =>
    iban
        ?.toUpperCase()
        .replace(/[^\dA-Z]/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();

export const sanitizedIban = (iban?: string) => iban?.replace(/\s+/g, '');

export const validateIbanForDirectDebit = async (
    studioId?: number,
    iban?: string
) => {
    const api = injectTSDI(Api);
    if (!iban) {
        return false;
    }
    if ((sanitizedIban(iban) || '').length < 15) {
        return 'errormessage.bank.account.convert.iban.invalid';
    }
    try {
        const { validIban, supportsSepaDirectDebit } =
            await api.client.ConnectApiBankAccountController.validateIbanAndLookupBic(
                {
                    iban,
                    organizationUnitId: studioId
                }
            );
        if (!validIban) {
            return 'errormessage.bank.account.convert.iban.invalid';
        }
        if (!supportsSepaDirectDebit) {
            return 'errormessage.bank.account.sepa.direct.debit.not.supported';
        }
        return false;
    } catch {
        return 'commons.error.runtime';
    }
};

export const validateAccountHolderForDirectDebit = async (
    accountHolder: string
) => {
    const api = injectTSDI(Api);
    if (!accountHolder) {
        return false;
    }
    try {
        const { valid } =
            await api.client.ConnectApiBankAccountController.validateAccountHolderName(
                {
                    accountHolder
                }
            );
        if (!valid) {
            return 'errormessage.bank.account.holder.invalid.characters.for.sepa';
        }
        return false;
    } catch {
        return 'commons.error.runtime';
    }
};
